import {
	SET_MULTI_ROOM,
	MULTI_ROOM_TOTAL,
	CURRENT_MULTI_ROOM_STEP,
} from '../actions/multiRoomActions'

const initialState = {
	isMultiRoom: false,
	multiRoomTotal: null,
	currentMultiRoomStep: null
}

export default function multiRoomReducer(state = initialState, action) {
	switch(action.type) {

		case SET_MULTI_ROOM:
			return {
				...state,
				isMultiRoom: action.payload,
			}

		case MULTI_ROOM_TOTAL:
			return {
				...state,
				multiRoomTotal: action.payload,
			}

		case CURRENT_MULTI_ROOM_STEP:
			return {
				...state,
				currentMultiRoomStep: action.payload,
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/multiRoomReducers.js